export default "__VITE_ASSET__DKpex0y7__"